import client from "./client";

// --- PRIVATE USER DATA ---
export const getStats = () =>
  client.get("/users/stats").then((res) => res.data);

export const getProfile = () =>
  client.get("/users/profile").then((res) => res.data);

export const getMyCompetitions = () =>
  client.get("/users/my-competitions").then((res) => res.data);

// --- PUBLIC DATA ---
export const getCompetitions = () =>
  client.get("/users/explore").then((res) => res.data);

// Check enrollment
export const checkEnrollment = (competitionId) =>
  client
    .get(`/users/check-enrollment/${competitionId}`)
    .then((res) => res.data);

// --- ARENA / QUIZ DATA ---

// Fetches questions WITHOUT answers for the student
export const getQuizQuestions = (competitionId) =>
  client.get(`/users/arena/questions/${competitionId}`).then((res) => res.data);

// Submits the final choices for grading
export const submitQuizResults = (competitionId, payload) =>
  client
    .post(`/users/arena/submit/${competitionId}`, payload)
    .then((res) => res.data);

// --- HUB & SLOT DATA ---

// 1. Fetches the Hub data (registration, status, notice text)
export const getHubDetails = (competitionId) =>
  client.get(`/users/hub/${competitionId}`).then((res) => res.data);

// 2. Fetches available slots for a specific competition
export const getAvailableSlots = (competitionId) =>
  client.get(`/users/slots/${competitionId}`).then((res) => res.data);

// 3. Saves the user's chosen slot
export const selectSlot = (competitionId, slotId) =>
  client
    .post(`/users/select-slot`, { competitionId, slotId })
    .then((res) => res.data);

//---Assignment submission ---
// Ensure this matches your backend route /api/stage-two/:competitionId
// Change this in userApi.js
export const getStageTwo = (compId) => client.get(`/users/stage-two/${compId}`);
export const submitStageTwo = (payload) =>
  client.post(`/users/stage-two/submit`, payload);

//--Internship related api--
export const getMyInternships = () =>
  client.get("/users/my-internships").then((res) => res.data);

export const getInternshipSpecificOneDetails = (internshipId) =>
  client.get(`/users/getSpecificInternshipData/${internshipId}`).then((res) => res.data);

//  return and passed the reportData body
export const submitWeeklyReport = (reportData) =>
  client.post("/users/submit-report", reportData).then((res) => res.data);




//---Voilation reporting---
export const reportViolation = (payload) =>
  client.post("/users/arena/violation", payload).then((res) => res.data);

